export const receiptsLookupFieldDropdown =  [
	{
	  title: "By RMA Number",
	  value: "rmaNumber"
	},
	{
		title: "By Serial Number",
		value: "serialNumber"
	  }
];



// WEBPACK FOOTER //
// ./src/pages/fxoReprintLabels/filter/rmaLookupFieldDropdown.js